import { Currency } from '@/constants';
import { isBtcLikeCurrency } from '@/utils';

const createBlackListKey = (currency: Currency) => `${currency}_bl`;

const isBlackListSupported = (currency: Currency) => isBtcLikeCurrency(currency);

export const getBlackList = (currency: Currency) => {
  if (!isBlackListSupported(currency)) {
    return new Set<string>();
  }

  const key = createBlackListKey(currency);

  return new Set<string>(JSON.parse(sessionStorage.getItem(key) ?? '[]'));
};

export const addToBlackList = (currency: Currency, orderId: string) => {
  if (!isBlackListSupported(currency)) {
    return;
  }

  const blackList = getBlackList(currency);

  blackList.add(orderId);

  sessionStorage.setItem(createBlackListKey(currency), JSON.stringify([...blackList]));
};

export const cleanBlacklist = (currency: Currency, orderIds: string[]) => {
  if (!isBlackListSupported(currency)) {
    return;
  }

  const blackList = getBlackList(currency);

  if (blackList.size === 0) {
    return;
  }

  const aliveIds = new Set(orderIds);

  blackList.forEach((value) => {
    if (!aliveIds.has(value)) {
      blackList.delete(value);
    }
  });
};

export const filterByBlackList = <TOrder extends { id: string }>(currency: Currency, items: TOrder[]) => {
  if (!isBlackListSupported(currency)) {
    return items;
  }

  const blackList = getBlackList(currency);

  return items.filter(({ id }) => !blackList.has(id));
};
